<div class="container">
    <app-local-spinner *ngIf="isLoading" [blur]="true" loadingText="Creating ticket..."></app-local-spinner>
    <div class="ticket-container">
        <!-- Header -->
        <div class="page-header">
            <div class="breadcrumb">
                <span class="breadcrumb-item" (click)="goBack()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
                    </svg>
                    Tickets
                </span>
                <span class="breadcrumb-separator">></span>
                <span class="breadcrumb-item active">Create Ticket</span>
            </div>
            <button class="btn-back" (click)="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                </svg>
                Go Back
            </button>
        </div>
        <div class="form-scroll-area">
            <!-- Form Section -->
            <div class="form-section">
                <div class="category-toggle-container" *ngIf="isReceivingAdmin">
                    <label class="form-label">Ticket For <span class="required-star">*</span></label>
                    <div class="category-toggle">
                        <button *ngIf="router.url.includes('/receiving-admin')" type="button" class="toggle-btn" [class.active]="currentCategory === 'company'"
                            (click)="onCategoryToggle('company')">
                            Company Ticket
                        </button>
                        <button type="button" class="toggle-btn" [class.active]="currentCategory === 'po'"
                            (click)="onCategoryToggle('po')">
                            PO Ticket
                        </button>
                    </div>
                </div>

                <!-- Company Selection -->
                <div class="form-group" *ngIf="isReceivingAdmin && currentCategory === 'company'">
                    <label class="form-label">Select Company <span class="required-star">*</span></label>
                    <div class="select-wrapper">
                        <select class="form-input" [(ngModel)]="ticketForm.company_id" [class.error]="errors['company_id']">
                            <option [value]="undefined" disabled selected>Select a company</option>
                            <option *ngFor="let company of companyList" [value]="company.schema_name">
                                {{ company.company_name }}
                            </option>
                        </select>
                        <div class="select-spinner" *ngIf="isLoadingCompanies">
                            <svg class="animate-spin" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                                </circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </div>
                    <div class="error-message" *ngIf="errors['company_id']" [class.show]="errors['company_id']">
                        {{errors['company_id']}}
                    </div>
                </div>

                <!-- Subject -->
                <div class="form-group">
                    <label class="form-label">Subject<span class="required-star">*</span></label>
                    <input type="text" class="form-input" [(ngModel)]="ticketForm.subject" [class.error]="errors['subject']"
                        placeholder="Enter ticket subject" maxlength="100" (input)="updateSubjectCount()">
                    <div class="error-message" *ngIf="errors['subject']" [class.show]="errors['subject']">
                        {{errors['subject']}}
                    </div>
                    <div class="char-counter">{{subjectCounter}}</div>
                </div>

                <!-- Description -->
                <div class="form-group">
                    <label class="form-label">Description<span class="required-star">*</span></label>
                    <textarea class="form-textarea" [(ngModel)]="ticketForm.description"
                        [class.error]="errors['description']" placeholder="Describe the issue in detail..." maxlength="500"
                        (input)="updateDescriptionCount()"></textarea>
                    <div class="error-message" *ngIf="errors['description']" [class.show]="errors['description']">
                        {{errors['description']}}
                    </div>
                    <div class="char-counter">{{descriptionCounter}}</div>
                </div>

                <!-- File Upload -->
                <div class="file-upload-section">
                    <label class="form-label">Attachments</label>

                    <div class="uploaded-images" *ngIf="uploadedPreviews.length > 0">
                        <div class="uploaded-image-item" *ngFor="let preview of uploadedPreviews; let i = index">
                            <img [src]="preview" alt="Uploaded image">
                            <button class="remove-image" (click)="removeImage(i)" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <p class="upload-note">Note: You can attach maximum 5 images</p>

                    <input type="file" id="fileInput" class="file-input-hidden" accept="image/*" multiple
                        (change)="onFileSelect($event)">

                    <button class="btn-attach-file" (click)="openFileSelector()" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
                        </svg>
                        Attach File
                    </button>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions">
            <button class="btn btn-cancel" (click)="cancel()" type="button">Cancel</button>
            <button class="btn btn-submit" (click)="createTicket()" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" style="width: 18px; height: 18px; margin-right: 6px;">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Create Ticket
            </button>
        </div>
    </div>
</div>